/**
 * Global window binding yardimcilari
 */

export function registerWindowBindings(bindings: Record<string, any>): void {
    Object.entries(bindings).forEach(([key, value]) => {
        (window as any)[key] = value;
    });
}
